import { useCallback, useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";

import Loading from "../../../components/Loading";
import Menu from "../../../components/Menu";

import api from "../../../services/api";

const OPTIONS_FOR_BOOL = [
    { label: "Computável", value: true },
    { label: "Não Computável", value: false }
]

const initialState = {
    id: null,
    descricao: "",
    computavel: false
}

export default function AcabamentoParadas() {
    const [data, setData] = useState([]);
    const [form, setForm] = useState({...initialState});

    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const toast = useRef();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const fetchData = useCallback(() => {
        api.get("acabamento/paradas").then(response => {
            setData(response.data);
        }).catch(error => {
            setData([]);
        });
    }, []);

    const handleDelete = (rowData) => {
        confirmDialog({
            header: "Excluir",
            message: "Você tem certeza que deseja excluir esse registro?",
            acceptLabel: 'Excluir',
            acceptClassName: 'p-button-danger',
            rejectLabel: "Cancelar",
            rejectClassName: "p-button-secondary",
            accept: () => {
                setIsLoading(true);
                api.get(`acabamento/paradas/${rowData.id}/delete`).then(response => {
                    fetchData();
                    setIsLoading(false);
                    showSuccess(response);
                }).catch(error => {
                    showError(error);
                    setIsLoading(false);
                });
            }
        });
    }

    const handleEdit = (rowData) => {
        setForm({...rowData});
        setIsEditing(true);
        setIsVisible(true);
    }

    const handleSubmit = () => {
        if(isEditing && form.id !== null) {
            setIsLoading(true);
            api.put(`acabamento/paradas/${form.id}/update`, form).then(response => {
                fetchData();
                setIsLoading(false);
                onHide();
                showSuccess(response);
            }).catch(error => {
                setIsLoading(false);
                showError(error);
            });
        } else {
            setIsLoading(true);
            api.post('acabamento/paradas', form).then(response => {
                fetchData();
                setIsLoading(false);
                onHide();
                showSuccess(response);
            }).catch(error => {
                setIsLoading(false);
                showError(error);
            });
        }
    }

    const onHide = () => {
        if(isEditing) {
            setForm({...initialState});
            setIsEditing(false);
        }
        setIsVisible(false);
    }

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    if(isLoading)
        return <Loading />
    
    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <Card
                className="p-m-1"
                title="Cadastro de Paradas"
            >
                <Dialog
                    className="p-m-1"
                    footer={() => (
                        <div>
                            <Button
                                className="p-button-secondary"
                                label="Cancelar"
                                onClick={onHide} 
                            />
                            <Button 
                                className="p-button-success"
                                label="Salvar"
                                onClick={handleSubmit}
                            />
                        </div>
                    )}
                    header={isEditing ? "Editar Parada" : "Cadastrar Parada"}
                    style={{ width: "35vw" }}
                    visible={isVisible}
                >
                    <div className="p-fluid">
                        <div className="p-field">
                            <label htmlFor="descricao">Descrição: </label>
                            <InputText
                                onChange={e => setForm({...form, descricao: e.target.value})} 
                                value={form.descricao}
                            />
                        </div>
                        <div className="p-field">
                            <Dropdown
                                onChange={e => setForm({...form, computavel: e.value })}
                                options={OPTIONS_FOR_BOOL}
                                value={form.computavel}
                            />
                        </div>
                    </div>
                </Dialog>

                <div className="p-d-flex p-flex-row p-jc-end">
                    <Button 
                        className="p-button-success p-m-1"
                        icon="pi pi-plus"
                        onClick={() => {
                            setIsVisible(true);
                        }}
                    />
                </div>

                <DataTable
                    emptyMessage="Nenhum registro encontrado."
                    responsiveLayout="scroll"
                    size="small"
                    value={data}
                >
                    <Column header="ID" field="id" sortable />
                    <Column header="Descrição" field="descricao" sortable />
                    <Column header="Computável" field="computavel" sortable body={(rowData) => {
                        if(rowData.computavel)
                            return "Computável"
                        return "Não Computável"
                    }} />
                    <Column header="Ações" body={(rowData) => (
                        <div>
                            <Button 
                                className="p-button-primary p-m-1"
                                icon="pi pi-pencil"
                                onClick={() => handleEdit(rowData)}
                                title="Clique para editar"
                            />
                            <Button 
                                className="p-button-danger p-m-1"
                                icon="pi pi-trash"
                                onClick={() => handleDelete(rowData)}
                                title="Clique para excluir"
                            />
                        </div>
                    )} /> 
                </DataTable>
            </Card>
        </div>
    )
}